import React, {useContext, useEffect, useState} from 'react';
import {useLocation, useNavigate, useOutletContext, useParams, useSearchParams} from "react-router-dom";
import cn from "classnames";
import {IconBox, Type as T} from "@infobis/ui-styles-utils";

import {getColorByStatusUnits} from "@utils/getColorByStatusUnit";

import {useTypedSelector} from "@hooks/useTypedSelector";

import MonitoringBackLink from "@modules/card/backLink/MonitoringBackLink";

import {Service} from "@context/map/mutableStore";
import UnitService from "@context/map/units/unitsStore";

import {Align, Color, Crop, Unit} from "@baseTypes/baseType";
import {Constants} from "@baseTypes/constants";

import Container from "@elements/container/Container";
import List from "@elements/list/List";
import ItemList from "@elements/itemList/ItemList";
import Sticker from "@elements/sticker/Sticker";
import Line from "@elements/flexLine/FlexLine";

import st from "./detailsUnits.module.scss"
import { ApplicationContext } from "@pages/monitoring/map/MapPage";
import colors from "@infobis/ui-styles-utils/colors";


const DetailsUnit = () => {
  
  let serviceStatus: any = useContext(Service);
  
  let navigate = useNavigate();
  let [searchParams, setSearchParams] = useSearchParams();
  let location = useLocation();
  let params = useParams();
  
  let {unitId} = params
  
  let [detailedUnit, setDetailedUnit] = useState({} as Unit)
  let ctx = useContext(ApplicationContext)

  useEffect(() => {
    if (unitId && ctx?.pixiContext) {
      ctx?.pixiContext.updateState(state => ({...state,
        showOnMap: true,
        selectedUnits: unitId!.split(":") }))
    }
  }, [unitId, ctx])

  let {

  } = useTypedSelector(state => state.units)
  
  useEffect(() => {
    
    let {units, hashUnits, type, options, meta} = UnitService
    if (unitId) {
      let unitData = hashUnits[unitId] || {};
      
      if (Object.entries(unitData).length) {
        setDetailedUnit(unitData)
      }
    }
  }, [unitId, serviceStatus?.unitUpdate.lastUpdate])
  
  
  const {
    dynamic,
    glid,
    name,
    type,
    typeName
  } = detailedUnit
  return (
    <Container
      blur={true}
      className={st.container}
      color={Color.White}
      style={{
        height: "100%",
        borderRadius: "0 15px 15px 0",
        padding: "24px"
      }}
    >
      <MonitoringBackLink
        path={"/map/units"}
        title={Constants.Unit}
      />
      
      <Container
        className={st.content}
        style={{
          marginTop: "24px"
        }}
        radius={true}
      >
        <List>
          <ItemList>
            <Sticker>
              <List>
                <ItemList className={st.title}>
                  <Line className={st.title__name}>
                    <IconBox icon={T.IconName.Analytics} color={colors.CONTROL_DEFAULT_ICON_ICON}
                             className={st.icon}/>
                    <div>{name}</div>
                  </Line>
                  <Line align={Align.SpaceBetween} className={st.title__area}>
                    <Line>
                      Актуальные данные
                    </Line>
                    <Line>
                      {"34112213123"}
                    </Line>
                  </Line>
                  <Line align={Align.SpaceBetween} className={st.title__area}>
                    <Line>
                      <IconBox icon={T.IconName.Vehicle} color={colors.CONTROL_DEFAULT_ICON_ICON}
                               className={st.icon}/>
                      <div>{typeName}</div>
                    </Line>
                    <Line>
                      <div className={cn(st.icon, st.circle)}
                           style={{background: getColorByStatusUnits(dynamic?.unitState)}}/>
                      {"34112213123"} км/ч
                    </Line>
                  </Line>
                  <Line className={st.title__area}>
                    <IconBox icon={T.IconName.Vehicle} color={colors.CONTROL_DEFAULT_ICON_ICON}
                             className={st.icon}/>
                    
                    <div>66 Л</div>
                  </Line>
                  <Line className={st.title__area}>
                    <IconBox icon={T.IconName.Location} color={colors.CONTROL_DEFAULT_ICON_ICON}
                             className={st.icon} style={{transform: "scale(1.5)"}}/>
                    <div>
                      Ставропольский край, Изобильненский городской округ
                    </div>
                  </Line>
                </ItemList>
                
                {dynamic?.position.map((crop: Crop) => {
                  const {
                    id,
                    reproduction,
                    color,
                    endDate,
                    varieties,
                    title
                  } = crop
                  return (
                    <ItemList>
                      <Line className={st.colorTitle}>
                        <div className={cn(st.icon, st.square)} style={{background: `#${color}`}}/>
                        {title}
                      </Line>
                      {varieties ? <Line align={Align.SpaceBetween}>
                        <Line>
                          Cорт
                        </Line>
                        <Line>
                          {varieties}
                        </Line>
                      </Line> : null}
                      {reproduction ? <Line align={Align.SpaceBetween}>
                        <Line>
                          Репродукция
                        </Line>
                        <Line>
                          {reproduction}
                        </Line>
                      </Line> : null}
                    </ItemList>
                  )
                })}
              </List>
            </Sticker>
          </ItemList>
        </List>
      </Container>
    </Container>
  )
}
export default DetailsUnit


